import { IAction } from '../models/action';
import { User } from '../models/user';

import { USER_CREATE_SUCCESS,  USER_SESSION_SET_SUCCESS, USER_CHECK_SESSION_SUCCESS, USER_INFO_FORM_SUBMISSION_SUCCESS, USER_INFO_FORM_CHECK_SUCCESS, USER_INFO_FORM_DISMISSED_SUCCESS,  USER_CONTACT_FORM_UPDATE_SUCCESS} from '../handlers.actions';

const initUserStore: any = (): User => ({    
    id: null,
    session: false,
    error: false,
    createdAt: null,
    cookieName: null,
    expiresAt: null,
    userInfo: {
        userInfoSubmission: false,
        userInfoDismissed: false,
        createdAt: null,
        expiresAt: null
    }    
});

/** USER REDUCER */
export const userReducer = (state = initUserStore(), action: IAction) => {
    switch (action.type) {
          case USER_CHECK_SESSION_SUCCESS:
          case USER_CREATE_SUCCESS:              
              return {...state, ...action.payload};
          case USER_SESSION_SET_SUCCESS:
              return {...state,  ...action.payload};
          case USER_INFO_FORM_CHECK_SUCCESS:
          case USER_INFO_FORM_SUBMISSION_SUCCESS:
          case USER_INFO_FORM_DISMISSED_SUCCESS:
               const new_data = state;
               new_data.userInfo = action.payload;
               return {...new_data};         
          default:
              return state;
    }
}

const initStore: any = () => ({isValid:false, user:{firstName:null, lastName:null, email:null, zip:null, address: null, address2:null, city:null, state:null}});

export const contactFormReducer = (state = initStore(), action:IAction) => {
    switch(action.type){
        case USER_CONTACT_FORM_UPDATE_SUCCESS:          
            return {...action.payload};
        default:
            return state;
    }
}